import { DealerID } from "./Dealer";
import { DMSIDS } from "./Dms";

export type PreviousDMSKeyID = number;

export interface PreviousDMSKey {
  created_on: string;
  previous_dms_key_id: PreviousDMSKeyID; // The unique identifier of the previous DMS key
  dealer_id: DealerID; // The dealer the DMS key belonged to
  dms_id: DMSIDS; // The DMS the DMS key belonged to
  dmsv3_key: string; // The DMSv3 key of the deleted dealer DMS
}
